module.exports = __webpack_public_path__ + "static/media/weather-cloudy.5114ea50.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/weather/svg/weather-cloudy.svg
// module id = 789
// module chunks = 0